export default {"LABEL":"Rules 规则","DESC":"颜色主题定义的使用规则说明.","COMPONENTS":{"__markdown":true}}